import axios from 'axios';
import * as Yup from 'yup';

const apiBaseUrl = process.env.REACT_APP_CONSEILLER_API_BASE_URL;
const apiValidation = async url => {
  const result = await axios.get(url);

  return result?.data;
};

export const sepaSchema = Yup.object().shape({
  iban: Yup.string()
    .matches(/[a-zA-Z0-9]{14,34}/, "Le format de l'IBAN n'est pas correct")
    .required('Veuillez renseigner un IBAN')
    .test('backend-iban-check', "L'IBAN renseigné n'est pas valide", async (value = '') => {
      try {
        return await apiValidation(`${apiBaseUrl}/validation/iban/${value}`);
      } catch (e) {
        return false;
      }
    }),
  bic: Yup.string()
    .matches(/[a-zA-Z0-9]{8,11}/, "Le format du BIC n'est pas correct")
    .required('Veuillez renseigner un BIC')
    .test('backend-bic-check', "Le BIC renseigné n'est pas valide", async (value = '') => {
      try {
        return await apiValidation(`${apiBaseUrl}/validation/bic/${value}`);
      } catch (e) {
        return false;
      }
    }),
  address: Yup.string().required('Veuillez renseigner une adresse'),
  zipcode: Yup.string()
    .matches(/[0-9]{5}/, 'Le code postal doit être composé de 5 chiffres')
    .required('Veuillez renseigner un code postal'),
  city: Yup.string().required('Veuillez renseigner une ville'),
});
